import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const LazyPrivacy = lazy(async () => await import('./privacy'));

export const PrivacyRouter: RouteObject = {
  path: 'privacy',
  element: <LazyPrivacy />
};
